export const first = (bookId, projectId, images = {}) => {
  return `
  <h1 class="title">Getting started</h1>
  <p></p>
  <p>Welcome to hello ivy! <span type="emoji" data="👋">👋</span></p>
  <p></p>
  <blockquote>
    <p>Hello Ivy is an easy-to-use app to write, plan, take notes and track tasks. Manage your life, work or any other project all in one place.</p>
  </blockquote>
  <p></p>
  <p></p>
  <h3>L<strong>et's teach you some of the basics</strong></h3>
  <ul data-type="todo_list" class="todo_list">
    <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
      <p>A <strong>page </strong>like this is flexible and can be anything, from a simple <button class="mention" href="/space/${bookId}?page=${projectId}">@Grocery list</button> to an elaborate business plan.</p>
    </li>
    <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
      <p>Create <strong>new pages</strong> by using the "<strong>+</strong>"<strong> </strong>icon in the sidebar on theleft.</p>
    </li>
    <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
      <p>Everything you do within the app is <strong>saved instantly and automatically</strong>.</p>
    </li>
    <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
      <p>Drag and drop spaces, pages, images, checkboxes and list items.</p>
    </li>
    <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
      <p>To go back to your <strong>Spaces page</strong> click on the <em>arrow icon</em> in the bottom left corner.</p>
    </li>
    <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
      <p>Write [] on a new line to quickly insert a checkbox.</p>
    </li>
  </ul>
  <p></p>
  <p></p>
  <h3><strong>Quick tip:</strong></h3>
  <p>Press <strong>ctrl + ?</strong> to easily switch between light and dark themes <span type="emoji" data="🌗">🌗</span>.</p>
  <p></p>
  <p></p>
  <h3>Add images</h3>
  <p><span type="image" src="${images['first.jpg']?.url}"  id="${images['first.jpg']?.id}"
      style="width: 50%; position: relative; display: inline-block;
                      line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px"
      class="shadow-smooth" ischateditor="false" contenteditable="false"><span contenteditable="false"></span><span
        contenteditable="false"></span><span contenteditable="false"></span><img
        src="${images['first.jpg']?.url}"  id="${images['first.jpg']?.id}"
        style="width: 50%; position: relative; display: inline-block;
                      line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px"
        class="shadow-smooth" ischateditor="false"></span><span type="image"
        src="${images['second.png']?.url}"  id="${images['second.png']?.id}" style="width: 30%; position: relative; display: inline-block;
                  line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px"
      ischateditor="false" contenteditable="false"><span contenteditable="false"></span><span
        contenteditable="false"></span><span contenteditable="false"></span><img
        src="${images['second.png']?.url}"  id="${images['second.png']?.id}" style="width: 30%; position: relative; display: inline-block;
                  line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px"
        ischateditor="false"></span></p>
  <p><em>Double-click on images to zoom-in and view more options.</em></p>
  <p></p>
  <p></p>
  <h3><strong>A few helpful tips &amp; tricks:</strong></h3>
  <ul data-type="todo_list" class="todo_list">
    <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
      <p>Use the "<strong>@</strong>" symbol to internally link to other pages or spaces.</p>
    </li>
    <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
      <p>Use "<strong>:</strong>" to insert emoji's <span type="emoji" data="😁">😁</span><span type="emoji" data="😎">😎</span><span type="emoji" data="💯">💯</span></p>
    </li>
    <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
      <p>When you hover over the sidebar an icon appears at the top, click on this to enable focus mode.</p>
    </li>
    <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
      <p>Select text to <a target="_blank" rel="noopener noreferrer nofollow" href="https://helloivy.co/">create links</a>, <span style="color: rgb(235,88,87)" type="color">change text color</span>, <mark data-color="rgb(255,235,53)" style="background-color: rgb(255,235,53)">highlight text</mark> and more...</p>
    </li>
    <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
      <p>Press <strong>ctrl + 0</strong> for keyboard shortcuts.</p>
    </li>
    <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
      <p>Use the share menu in the top right corner to share your pages.</p>
    </li>
  </ul>
  <p></p>
  <p>There's a lot more to do but it's best to start exploring and see for yourself<span type="emoji" data="👀">👀</span>!
  </p>
  <p></p>
  <p></p>
  <h3>Download the desktop apps</h3>
<p>Download the desktop and mobile apps right here:</p>
<p><a target="_blank" rel="noopener noreferrer nofollow"
    href="https://helloivy.co/downloads">https://helloivy.co/downloads</a></p>
<p></p>
<p></p>
<h3>Enjoy organizing your life.</h3>
<p><em>The hello ivy team.</em></p>
<p></p>
<p><span type="image" src="${images['third.png']?.url}"  id="${images['third.png']?.id}" style="width: 38%; position: relative; display: inline-block;
                line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px" class=""
    ischateditor="false" contenteditable="false"><span contenteditable="false"></span><span
      contenteditable="false"></span><span contenteditable="false"></span><img
      src="${images['third.png']?.url}"  id="${images['third.png']?.id}" style="width: 38%; position: relative; display: inline-block;
                line-height: 0; vertical-align: text-bottom; max-width: 98%; min-width: 100px" class=""
      ischateditor="false"></span></p>
  <p></p>
  <p></p>
  <hr>
  <p></p>
  <h3><strong>GO PRO.</strong></h3>
  <p>Upgrading to <strong><button label="Hello Ivy Pro " class="localLink">Hello Ivy Pro </button></strong> gives you <u>unlimited</u> spaces, pages, storage and unlocks all features for only <strong>$5 per month</strong> (or just $48 per year if you pay annually).</p>
  <p></p>
  <p></p>
  <p></p>
  `
}

export const second = (bookId, projectId) => {
  return `
    <h1 class="title">To-do list</h1>
    <p>Getting things done.</p>
    <p></p>
    <p><strong>Today</strong></p>
    <ul data-type="todo_list" class="todo_list">
      <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
        <p>Sort out my files <span type="emoji" data="📂">📂</span><span type="emoji" data="📚">📚</span></p>
      </li>
      <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
        <p>Ask my boss for a raise</p>
      </li>
      <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
        <p>Call the doctor between 09:00 and 12:00</p>
        <ul data-type="todo_list" class="todo_list">
          <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
            <p>Don't forget to explain my medical file</p>
          </li>
          <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
            <p>Ask if I can take painkillers</p>
          </li>
        </ul>
      </li>
      <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
        <p>Walk the dog (twice!) <span type="emoji" data="🐶">🐶</span></p>
      </li>
    </ul>
    <p></p>
    <p><strong>Before Friday</strong></p>
    <ul data-type="todo_list" class="todo_list">
      <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
      <p>Buy dog food (Gluten-free)</p>
      </li>
      <li data-type="todo_item" data-done="false" class="todo-unchecked order-none">
        <span class="todo-checkbox" contenteditable="false"></span>
        <div class="todo-content">
          <p>Go to the grocery store <button class="mention" href="/space/${bookId}?page=${projectId}">@Grocery list</button></p>
        </div>
      </li>
      <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
        <p>Get my surfboard repaired <span type="emoji" data="🏄‍♀️">🏄‍♀️</span></p>
      </li>
      <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
        <p>Call my dad</p>
      </li>
      <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
        <p>Write a review about the new James Bond movie</p>
      </li>
      <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
        <p>Do some Christmas shopping <span type="emoji" data="🎄">🎄</span></p>
      </li>
    </ul>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
  `
}

export const third = () => {
  return `
    <h1 class="title">Grocery list</h1>
    <p>A trip to the supermarket.</p>
    <p></p>
    <blockquote><p>"Whoever said money can't buy happiness didn't know where to shop" - Unknown.</p></blockquote>
    <p></p>
    <p><strong>What we need:</strong></p>
    <ul data-type="todo_list" class="todo_list">
      <li data-type="todo_item" data-done="false" class="todo-unchecked order-none"><span class="todo-checkbox" contenteditable="false"></span><div class="todo-content"><p>Milk <span type="emoji" data="🥛"></span> (of course)</p></div></li>
      <li data-type="todo_item" data-done="false" class="todo-unchecked order-none"><span class="todo-checkbox" contenteditable="false"></span><div class="todo-content"><p>Cheese <span type="emoji" data="🧀"></span></p></div></li>
      <li data-type="todo_item" data-done="false" class="todo-unchecked order-none"><span class="todo-checkbox" contenteditable="false"></span><div class="todo-content"><p>Broccoli <span type="emoji" data="🥦"></span></p></div></li>
      <li data-type="todo_item" data-done="false" class="todo-unchecked order-none"><span class="todo-checkbox" contenteditable="false"></span><div class="todo-content"><p>Carrots <span type="emoji" data="🥕"></span></p></div></li>
      <li data-type="todo_item" data-done="false" class="todo-unchecked order-none"><span class="todo-checkbox" contenteditable="false"></span><div class="todo-content"><p>Dog food <span type="emoji" data="🐶"></span></p></div></li>
      <li data-type="todo_item" data-done="false" class="todo-unchecked order-none"><span class="todo-checkbox" contenteditable="false"></span><div class="todo-content"><p>Milk chocolate <span type="emoji" data="🍫"></span></p></div></li>
      <li data-type="todo_item" data-done="false" class="todo-unchecked order-none"><span class="todo-checkbox" contenteditable="false"></span><div class="todo-content"><p>Cookies <span type="emoji" data="🍪"></span></p></div></li>
      <li data-type="todo_item" data-done="false" class="todo-unchecked order-none"><span class="todo-checkbox" contenteditable="false"></span><div class="todo-content"><p>Peanuts <span type="emoji" data="🥜"></span></p></div></li>
      <li data-type="todo_item" data-done="false" class="todo-unchecked order-none"><span class="todo-checkbox" contenteditable="false"></span><div class="todo-content"><p>Candles <span type="emoji" data="🔥"></span></p></div></li>
      <li data-type="todo_item" data-done="false" class="todo-unchecked order-none"><span class="todo-checkbox" contenteditable="false"></span><div class="todo-content"><p>Coffee <span type="emoji" data="☕"></span></p></div></li>
      <li data-type="todo_item" data-done="false" class="todo-unchecked order-none"><span class="todo-checkbox" contenteditable="false"></span><div class="todo-content"><p>Lemons <span type="emoji" data="🍋"></span></p></div></li>
      <li data-type="todo_item" data-done="false" class="todo-unchecked order-none"><span class="todo-checkbox" contenteditable="false"></span><div class="todo-content"><p>A new plant for the house <span type="emoji" data="🎋"></span></p></div></li>
      <li data-type="todo_item" data-done="false" class="todo-unchecked order-none"><span class="todo-checkbox" contenteditable="false"></span><div class="todo-content"><p>Beers <span type="emoji" data="🍺"></span></p></div></li>
      <li data-type="todo_item" data-done="true" class="todo-checked order-1"><span class="todo-checkbox" contenteditable="false"></span><div class="todo-content"><p>Strawberries <span type="emoji" data="🍓"></span></p></div></li>
      <li data-type="todo_item" data-done="true" class="todo-checked order-1"><span class="todo-checkbox" contenteditable="false"></span><div class="todo-content"><p>Cornflakes</p></div></li>
      <li data-type="todo_item" data-done="true" class="todo-checked order-1"><span class="todo-checkbox" contenteditable="false"></span><div class="todo-content"><p>Mayonaise</p></div></li>
    </ul>
    <p></p>
    <p></p>
  `
}

export const fourth = (bookId, projectId) => {
  return `
  <h1 class="title">My favorites</h1>
  <p></p>
  <h3><strong><u>Index:</u></strong></h3>
  <p><button class="mention" href="/space/${bookId}?page=${projectId}">@Movies</button></p>
  <p>@Books (almost finished...)</p>
  <p></p>
  <p>Also still add my favorite: </p>
  <ul>
    <li isevent="false" class="list-item select-none" id="0.879530216650021">
      <div class="list-item-content">
        <p><em>Wines</em></p>
      </div>
    </li>
  </ul>
  <ul>
    <li isevent="false" class="list-item select-none" id="0.879530216650021">
      <div class="list-item-content">
        <p><em>Recipes</em></p>
      </div>
    </li>
  </ul>
  <ul>
    <li isevent="false" class="list-item select-none" id="0.879530216650021">
      <div class="list-item-content">
        <p><em>Restaurants (in Stockholm)</em></p>
      </div>
    </li>
    <li isevent="false" class="list-item select-none" id="0.879530216650021">
      <div class="list-item-content">
        <p><em>Games</em></p>
      </div>
    </li>
  </ul>
  <p></p>
  `
}

export const fifth = () => {
  return `
  <h1 class="title">Movies</h1>
  <p>My all-time favorite movies</p>
  <p></p>
  <table>
    <tbody>
      <tr>
        <td colspan="1" rowspan="1" colwidth="246" style="background-color: rgb(180,238,57)">
          <p><strong>Title</strong></p>
        </td>
        <td colspan="1" rowspan="1" colwidth="80" style="background-color: rgb(180,238,57)">
          <p><strong>Year</strong></p>
        </td>
        <td colspan="1" rowspan="1" colwidth="105" style="background-color: rgb(180,238,57)">
          <p><strong>Length</strong></p>
        </td>
        <td colspan="1" rowspan="1" colwidth="109" style="background-color: rgb(180,238,57)">
          <p><strong>IMDB score</strong></p>
        </td>
        <td colspan="1" rowspan="1" style="background-color: rgb(180,238,57)">
          <p><strong>My review</strong></p>
        </td>
      </tr>
      <tr>
        <td colspan="1" rowspan="1" colwidth="246" style="">
          <p>The Prestige</p>
          <p></p>
        </td>
        <td colspan="1" rowspan="1" colwidth="80" style="">
          <p>2006</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="105" style="">
          <p>2h10m</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="109" style="">
          <p>8.5</p>
        </td>
        <td colspan="1" rowspan="1" style="">
          <p><span type="emoji" data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span><span type="emoji"
              data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span></p>
        </td>
      </tr>
      <tr>
        <td colspan="1" rowspan="1" colwidth="246" style="">
          <p>Shutter Island</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="80" style="">
          <p>2010</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="105" style="">
          <p>2h19m</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="109" style="">
          <p>8.2</p>
        </td>
        <td colspan="1" rowspan="1" style="">
          <p><span type="emoji" data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span><span type="emoji"
              data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span></p>
        </td>
      </tr>
      <tr>
        <td colspan="1" rowspan="1" colwidth="246" style="">
          <p>Lord of the Rings Trilogy</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="80" style="">
          <p>2001</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="105" style="">
          <p>Long</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="109" style="">
          <p>Avg. 8.8</p>
        </td>
        <td colspan="1" rowspan="1" style="">
          <p><span type="emoji" data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span><span type="emoji"
              data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span></p>
        </td>
      </tr>
      <tr>
        <td colspan="1" rowspan="1" colwidth="246" style="">
          <p>The Great Gatsby</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="80" style="">
          <p>2013</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="105" style="">
          <p>2h23m</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="109" style="">
          <p>7.2</p>
        </td>
        <td colspan="1" rowspan="1" style="">
          <p><span type="emoji" data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span><span type="emoji"
              data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span></p>
        </td>
      </tr>
      <tr>
        <td colspan="1" rowspan="1" colwidth="246" style="">
          <p>Gladiator</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="80" style="">
          <p>2000</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="105" style="">
          <p>2h51m</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="109" style="">
          <p>8.5</p>
        </td>
        <td colspan="1" rowspan="1" style="">
          <p><span type="emoji" data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span><span type="emoji"
              data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span></p>
        </td>
      </tr>
      <tr>
        <td colspan="1" rowspan="1" colwidth="246" style="">
          <p>The Wolf of Wall Street</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="80" style="">
          <p>2013</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="105" style="">
          <p>3h</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="109" style="">
          <p>8.2</p>
        </td>
        <td colspan="1" rowspan="1" style="">
          <p><span type="emoji" data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span><span type="emoji"
              data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span></p>
        </td>
      </tr>
      <tr>
        <td colspan="1" rowspan="1" colwidth="246" style="">
          <p>The Shawshank Redemption</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="80" style="">
          <p>1994</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="105" style="">
          <p>2h22m</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="109" style="">
          <p>9.3</p>
        </td>
        <td colspan="1" rowspan="1" style="">
          <p><span type="emoji" data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span><span type="emoji"
              data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span></p>
        </td>
      </tr>
      <tr>
        <td colspan="1" rowspan="1" colwidth="246" style="">
          <p>The Matrix</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="80" style="">
          <p>1999</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="105" style="">
          <p>2h16m</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="109" style="">
          <p>8.7</p>
        </td>
        <td colspan="1" rowspan="1" style="">
          <p><span type="emoji" data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span><span type="emoji"
              data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span></p>
        </td>
      </tr>
      <tr>
        <td colspan="1" rowspan="1" colwidth="246" style="">
          <p>John Wick</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="80" style="">
          <p>2014</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="105" style="">
          <p>1h41m</p>
        </td>
        <td colspan="1" rowspan="1" colwidth="109" style="">
          <p>7.4</p>
        </td>
        <td colspan="1" rowspan="1" style="">
          <p><span type="emoji" data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span><span type="emoji" data="⭐">⭐</span>
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <p></p>
  <p></p>
  <h3>Still add: </h3>
  <ul>
    <li isevent="false" class="list-item select-none" id="0.39890147760335637">
      <div class="list-item-content">
        <p>Palm Springs</p>
      </div>
    </li>
    <li isevent="false" class="list-item select-none" id="0.39890147760335637">
      <div class="list-item-content">
        <p>James Bond Casino Royale <span type="emoji" data="🔫">🔫</span></p>
      </div>
    </li>
    <li isevent="false" class="list-item select-none" id="0.39890147760335637">
      <div class="list-item-content">
        <p>Star Wars: The Empire Strikes Back </p>
      </div>
    </li>
  </ul>
  <p></p>
  `
}

export const sixth = () => {
  return `
  <h1 class="title">Meeting notes </h1>
  <p>Meeting notes of <u>September 5th</u>.</p>
  <p></p>
  <div type="block-color" style="background-color: #F8F8F8" class="color-block">💡 This meeting was delayed <strong>by 4 weeks</strong> due to COVID-19 issues.</div>
  <p></p>
  <h3><strong>Participants: </strong></h3>
  <p><span style="color: #3F40F2" type="color">@JamesJohnsen</span>, <span style="color: #3F40F2" type="color">@BernardWilson</span>, <span style="color: #3F40F2" type="color">@AnitaOakley</span></p>
  <p></p>
  <h3><span type="emoji" data="🗒">🗒</span><strong> Meeting agenda:</strong></h3>
  <ul>
    <li isevent="false" class="list-item select-none" id="0.42696387160855354">
      <div class="list-item-content">
        <p>Strategy for the 4th Quarter.</p>
        <ul>
          <li isevent="false" class="list-item select-none" id="0.42696387160855354">
            <div class="list-item-content">
              <p>Marketing budget should be decreased by 30% (low-season)</p>
            </div>
          </li>
          <li isevent="false" class="list-item select-none" id="0.42696387160855354">
            <div class="list-item-content">
              <p>Search for new office space </p>
            </div>
          </li>
          <li isevent="false" class="list-item select-none" id="0.42696387160855354">
            <div class="list-item-content">
              <p>The new CFO. What are we looking for?</p>
            </div>
          </li>
          <li isevent="false" class="list-item select-none" id="0.42696387160855354">
            <div class="list-item-content">
              <p>Q3 revenue review</p>
            </div>
          </li>
        </ul>
      </div>
    </li>
    <li isevent="false" class="list-item select-none" id="0.594968366568998">
      <div class="list-item-content">
        <p>New employee perks</p>
      </div>
    </li>
  </ul>
  <p></p>
  <h3><span type="emoji" data="✔️">✔️</span> Action Items:</h3>
  <ul data-type="todo_list" class="todo_list">
    <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
      <p>Calculate new marketing budget <span style="color: rgb(95, 95, 255)" type="color">@AnitaOakley</span></p>
    </li>
    <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
      <p>Write CFO job description <span style="color: rgb(95, 95, 255)" type="color">@BernardWilson</span></p>
    </li>
    <li class="todo_item todo_item" isevent="false" data-done="false" data-type="todo_item">
      <p><span style="color: rgb(95, 95, 255)" type="color">@JamesJohnsen, </span>go to office viewing instead of <span style="color: #3F40F2" type="color">@ErinHunt </span>on monday 13:45.</p>
    </li>
  </ul>
  <p></p>
  <h3>Not resolved:</h3>
  <ul>
    <li isevent="false" class="list-item select-none" id="0.7679096264229792">
      <div class="list-item-content">
        <p>The Q3 revenue review has been moved to next week's meeting. </p>
      </div>
    </li>
  </ul>
  <p></p>
  <p></p>
  <p></p>
  <p></p>
  `
}
